import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[80vh] flex items-center justify-center bg-white px-6">
      <div className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">404</p>
        <h1 className="text-5xl md:text-7xl font-bold text-[#0C2749]" style={{ fontFamily: "Outfit" }}>Seite nicht gefunden.</h1>
        <p className="text-slate-600 mt-4 max-w-md mx-auto">Die gesuchte Seite existiert nicht oder wurde verschoben.</p>
        <Link to="/" className="mt-8 inline-block bg-[#0C2749] hover:bg-[#2873B8] text-white px-8 py-3 rounded-sm font-medium transition-colors" data-testid="not-found-home">
          Zur Startseite
        </Link>
      </div>
    </section>
  );
}
